module.exports = __webpack_public_path__ + "img/system@2x (4).5237cd41.png";